export default __webpack_public_path__ + "static/media/arrowRight.861c234f.svg";